'use strict';

angular.module('uniromaLandingApp')
	.factory('EsterniStatiSpecService', ['$resource',function ($resource) {
		return {
			stati: $resource('api/esterniStatiSpecifici', {}, {
				'get': { method: 'GET',
							params: {},
							isArray: true,
							transformResponse: function (data) {
								data = angular.fromJson(data);
								return data;
							}
                },
                'getAll': { method: 'GET',
                	url: 'api/esterniAllStatiSpecifici',
					params: {},
					isArray: true,
					transformResponse: function (data) {
						data = angular.fromJson(data);
						return data;
					}
        }
			})
		};
	}]);
